module.exports = __webpack_public_path__ + "media/images/home/background-blurred-oranges-29e6092b186b63702a4ee7271dc4327f.jpg";